module.exports = __webpack_public_path__ + "static/media/fan-challenge-bg2.b6a11bd3.png";